export default __webpack_public_path__ + "static/media/svg-1.fc1d22b0.svg";